<template>
  <transition name="player-show">
    <div class="player">
      <div class="player-timeline">
        <vue-plyr
          ref="plyr"
          :options="{
            autoplay: true,
            loadSprite: false,
            controls: ['play-large', 'play', 'progress', 'current-time'],
            blankAudio: require('@/assets/blank.mp4')
          }"
        >
          <audio :src="targetAudioFile"></audio>
        </vue-plyr>
      </div>
      <div class="player-status-label">
        {{ prettyIsPlaying }} STOP
        {{ currentStopFormatted }}
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState([
      "currentStop",
      "playingNow",
      "isPlaying",
      "currentLang",
      "stops"
    ]),
    currentStopFormatted() {
      return this.$route.params.id < 10
        ? "0" + this.$route.params.id
        : this.$route.params.id;
    },
    targetAudioFile() {
      const stop = this.stops[this.$route.params.id - 1];
      return this.currentLang == "en" ? stop.audio : stop.audioMandarin;
    },
    prettyIsPlaying() {
      return this.isPlaying == true ? "PLAYING" : "PAUSED";
    }
  },
  watch: {
    // targetAudioFile: {}
    // // on stop change update and restart playback.
    // currentStop: {
    //   deep: true,
    //   handler() {
    //     this.updateSource();
    //   }
    // },
    // on language change update and restart playback.
    targetAudioFile: {
      deep: true,
      handler() {
        this.updateAndPlayback();
      }
    }
  },
  methods: {
    updateSource() {
      this.$refs.plyr.player.source = {
        type: "audio",
        title: `STOP ${this.currentStopFormatted}`,
        sources: [
          {
            src: this.targetAudioFile,
            type: "audio/mp3"
          }
        ]
      };
      console.log("Updated Source!");
    },
    handlePlayback() {
      console.log("Attempting playback!");
      this.playAudio();
    },
    async playAudio() {
      try {
        await this.$refs.plyr.player.play();
        console.log("Playing!");
      } catch (err) {
        await this.$refs.plyr.player.pause();
        console.log("Paused!");
      }
    },
    updateAndPlayback() {
      this.updateSource();
      this.handlePlayback();
    }
  },
  mounted() {
    console.log("HELLO");
    this.$refs.plyr.player.on("play", () => {
      this.$store.dispatch("toggleIsPlaying", true);
    });
    this.$refs.plyr.player.on("pause", () => {
      this.$store.dispatch("toggleIsPlaying", false);
    });

    // On mount update and restart playback.
    this.updateAndPlayback();
  }
};
</script>

<style lang="css" scoped>
.player {
  box-sizing: border-box;
  /* position: -webkit-sticky; */
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  padding: 1em 0 0.5em 0;
  background-color: white;

  transform: translateY(0);
  opacity: 1;
  height: 75px;
}

.player-show-enter-active,
.player-show-leave-active {
  transition: transform 0.3s, opacity 0.3s;
}

.player-show-enter,
.player-show-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

/* 
.player-timeline > p:nth-child(1) {
  position: fixed;
  bottom: 14px;
  left: 52px;
  z-index: 180;
  margin: 0;
} 
*/

.player-status-label {
  font-family: "swiss721boldcondensed", "Swiss721BT-BoldCondensed",
    "fallBackArial", sans-serif;
  color: #000000;
  letter-spacing: 0;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: normal;
  
  position: absolute;
  bottom: 24px;
  left: 86px;
}

</style>
<style>
.plyr__control {
  padding: 0 0 0 30px !important;
}
.plyr__control .icon--pressed, 
.plyr__control .icon--not-pressed {
  width: 34px;
  height: 34px;
  margin-top: 8px;
}
.plyr__progress {
  left: 20px !important;
  width: calc(100% - 40px) !important;
}
</style>